import http from './http.services'
import web3Services from './web3.services'

http.setToken(getToken())
// process.env.REACT_APP_API_URL

async function login(payload) {
  const { data } = await http.post(process.env.REACT_APP_API_URL + '/login', payload)
  return data
}

function getToken() {
  return localStorage.getItem('token')
}

async function logout() {
  // localStorage.clear()
  web3Services.clearLocalStorage()
}

function getCurrentUser() {
  const token = localStorage.getItem('token')
  if (token) return { token }
  else return ''
}

export default {
  login,
  logout,
  getToken,
  getCurrentUser,
}
